import { QuoteStatus } from '@/types/quotes.types';

export interface AnalyticsData {
  metrics: {
    totalQuotes: number;
    acceptanceRate: number;
    averageQuoteValue: number;
    monthlyRevenue: number;
    averageResponseTime: number;
  };
  quotePerformance: Array<{
    month: string;
    quotes: number;
    accepted: number;
  }>;
  statusDistribution: Array<{
    status: QuoteStatus;
    count: number;
    percentage: number;
  }>;
  revenueData: Array<{
    month: string;
    revenue: number;
    growth: number;
  }>;
  industryBreakdown: Array<{
    industry: string;
    quotes: number;
    percentage: number;
  }>;
  geographicData: Array<{
    state: string;
    quotes: number;
    revenue: number;
  }>;
  responseTimeData: Array<{
    month: string;
    avgResponseTime: number;
    target: number;
  }>;
  recentQuotes: Array<{
    id: string;
    companyName: string;
    industry: string;
    status: QuoteStatus;
    value: number;
    createdAt: string;
  }>;
}

export const generateMockAnalyticsData = (): AnalyticsData => {
  return {
    metrics: {
      totalQuotes: 1247,
      acceptanceRate: 68.5,
      averageQuoteValue: 125000,
      monthlyRevenue: 425000,
      averageResponseTime: 2.3,
    },
    quotePerformance: [
      { month: 'Jan', quotes: 89, accepted: 61 },
      { month: 'Feb', quotes: 95, accepted: 65 },
      { month: 'Mar', quotes: 102, accepted: 71 },
      { month: 'Apr', quotes: 118, accepted: 79 },
      { month: 'May', quotes: 134, accepted: 92 },
      { month: 'Jun', quotes: 145, accepted: 98 },
      { month: 'Jul', quotes: 152, accepted: 105 },
    ],
    statusDistribution: [
      { status: 'accepted', count: 471, percentage: 68.5 },
      { status: 'pending', count: 127, percentage: 18.5 },
      { status: 'declined', count: 63, percentage: 9.2 },
      { status: 'interested', count: 26, percentage: 3.8 },
    ],
    revenueData: [
      { month: 'Jan', revenue: 285000, growth: 12.5 },
      { month: 'Feb', revenue: 310000, growth: 8.8 },
      { month: 'Mar', revenue: 345000, growth: 11.3 },
      { month: 'Apr', revenue: 380000, growth: 10.1 },
      { month: 'May', revenue: 398000, growth: 4.7 },
      { month: 'Jun', revenue: 425000, growth: 6.8 },
      { month: 'Jul', revenue: 448000, growth: 5.4 },
    ],
    industryBreakdown: [
      { industry: 'Technology', quotes: 287, percentage: 31.2 },
      { industry: 'Healthcare', quotes: 245, percentage: 26.6 },
      { industry: 'Manufacturing', quotes: 156, percentage: 17.0 },
      { industry: 'Professional Services', quotes: 89, percentage: 9.7 },
      { industry: 'Retail', quotes: 67, percentage: 7.3 },
      { industry: 'Other', quotes: 76, percentage: 8.2 },
    ],
    geographicData: [
      { state: 'California', quotes: 245, revenue: 156000 },
      { state: 'Texas', quotes: 189, revenue: 134000 },
      { state: 'New York', quotes: 167, revenue: 125000 },
      { state: 'Florida', quotes: 134, revenue: 98000 },
      { state: 'Illinois', quotes: 98, revenue: 76000 },
      { state: 'Pennsylvania', quotes: 87, revenue: 65000 },
      { state: 'Ohio', quotes: 76, revenue: 54000 },
    ],
    responseTimeData: [
      { month: 'Jan', avgResponseTime: 3.2, target: 2.5 },
      { month: 'Feb', avgResponseTime: 2.8, target: 2.5 },
      { month: 'Mar', avgResponseTime: 2.6, target: 2.5 },
      { month: 'Apr', avgResponseTime: 2.4, target: 2.5 },
      { month: 'May', avgResponseTime: 2.2, target: 2.5 },
      { month: 'Jun', avgResponseTime: 2.3, target: 2.5 },
      { month: 'Jul', avgResponseTime: 2.1, target: 2.5 },
    ],
    recentQuotes: [
      {
        id: '1',
        companyName: 'TechFlow Solutions',
        industry: 'Technology',
        status: 'accepted',
        value: 185000,
        createdAt: '2024-07-20',
      },
      {
        id: '2',
        companyName: 'MedCare Group',
        industry: 'Healthcare',
        status: 'pending',
        value: 142000,
        createdAt: '2024-07-19',
      },
      {
        id: '3',
        companyName: 'BuildRight Manufacturing',
        industry: 'Manufacturing',
        status: 'accepted',
        value: 98000,
        createdAt: '2024-07-18',
      },
      {
        id: '4',
        companyName: 'ConsultPro Services',
        industry: 'Professional Services',
        status: 'interested',
        value: 76000,
        createdAt: '2024-07-17',
      },
      {
        id: '5',
        companyName: 'RetailMax Inc',
        industry: 'Retail',
        status: 'declined',
        value: 65000,
        createdAt: '2024-07-16',
      },
    ],
  };
};